e4.favorites = {
    bindEventsDone: false,
    init: function () {
        var jCart = jQuery( '.js-e-cart' );
        if ( jCart.length === 1) {
            jQuery.when.apply( jQuery, [
                e4.require.js( e4.settings.require.handlebars ),
            ] ).then( function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists-cart' );
                e4.favorites.bindEventsDone = false;
                e4.favorites.bindEvents();
                jQuery( '.js-e-product-favorites' ).find( '.dropdown-toggle' ).removeClass( 'disabled' );
            } );
        } 
        else if(jQuery('.js-e-orders-form').length === 1 ){
            jQuery.when.apply( jQuery, [
                e4.require.js( e4.settings.require.handlebars ),
            ] ).then( function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists-cart' );
                e4.favorites.bindEventsDone = false;
                e4.favorites.bindEvents();
                jQuery( '.js-e-product-favorites' ).find( '.dropdown-toggle' ).removeClass( 'disabled' );
            } );
            
        }
        else if ( jQuery( '.js-e-product-favorites' ).length > 0 ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists' );
                e4.favorites.bindEvents();
                jQuery( '.js-e-product-favorites' ).find( '.dropdown-toggle' ).removeClass( 'disabled' );
            } );
        }
        
        var jSearchForm = jQuery( '.js-e-search-form' );
        if ( jSearchForm.length === 1 ) {
            jSearchForm.one( 'loaded.e4.search', function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists' );
                e4.favorites.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        if ( e4.favorites.bindEventsDone === false ) {
            e4.favorites.bindEventsDone = true;
            jQuery( document )
                    .on( 'change', '.js-e-product-favorites-list-input', function ( event ) {
                        e4.favorites.toggleList( event.target );
                    } )
                    .on( 'change', '.js-e-product-favorites-list-cart', function ( event ) {
                        e4.favorites.addListToFavorites( event.target );
                    } )
                    .on( 'click', '.js-e-product-favorites-add-new-list-submit-btn', function ( event ) {
                        e4.favorites.createNewList( event.target );
                    } )
                    .on( 'keydown', '.js-e-product-favorites-add-new-list-name-input', function ( event ) {
                        if ( event.keyCode === 13 ) {
                            event.preventDefault();
                            event.stopPropagation();
                            jQuery( event.target ).closest( '.js-e-product-favorites-add-new-list' ).find( '.js-e-product-favorites-add-new-list-submit-btn' ).trigger( 'click' );
                        }
                    } )
                    .on( 'shown.bs.collapse', '.js-e-product-favorites-add-new-list', e4.favorites.setNewListInputFocus )
                    .on( 'show.bs.dropdown', '.js-e-product-favorites', e4.favorites.getListData )
                    .on( 'hidden.bs.dropdown', '.js-e-product-favorites', e4.favorites.clearLists );
        }
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.favorites.url,
            dataType: 'json',
            method: 'GET',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( jsonData ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( jsonData );
            }
        } );
        jqXHR.fail( function ( data, textStatus, errorThrown ) {
            console.error( data, textStatus, errorThrown );
        } );
    },
    addListToFavorites: function ( domInput ) {
        var jInput        = jQuery( domInput ),
            strListId     = jInput.data( 'listId' ),
            arrProductIds = [];
        jQuery( '.js-e-orderline' ).each( function ( index, domOrderline ) {
            var strProductId = jQuery( domOrderline ).data( 'productId' );
            arrProductIds.push( strProductId );
        } );
        e4.cc.ajax( {
            method: 'POST',
            url: e4.settings.ecom.cartFavorites.url,
            beforeSend: function () {
                jQuery( '.js-e-product-favorites-loader' ).addClass( 'is-loading' );
            },
            data: {
                productsIds: arrProductIds.join( ',' ),
                listId: strListId
            }
        }, function () {
            jQuery( '.js-e-product-favorites-loader' ).removeClass( 'is-loading' );
            jInput.prop( 'checked', true );
        } );
    },
    toggleList: function ( domInput ) {
        var jInput = jQuery( domInput );
        if ( jInput.prop( 'checked' ) === true ) {
            e4.favorites.addToList( jInput );
        }
        else {
            e4.favorites.removeFromList( jInput );
        }
    },
    addToList: function ( jInput ) {
        jInput.prop( 'disabled', true );
        e4.cc.ajax( {
            url: jInput.data( 'url-add' ) + '&Redirect=false'
        }, function () {
            jInput.prop( 'disabled', false );
            e4.favorites.checkForAnyActiveLists( jInput );
        } );
    },
    removeFromList: function ( jInput ) {
        jInput.prop( 'disabled', true );
        e4.cc.ajax( {
            url: jInput.data( 'url-remove' ) + '&Redirect=false'
        }, function () {
            jInput.prop( 'disabled', false );
            e4.favorites.checkForAnyActiveLists( jInput );
        } );
    },
    checkForAnyActiveLists: function ( jInput ) {
        var boolHasAnyChecked = jInput.closest( '.js-e-product-favorites-lists' ).find( '.js-e-product-favorites-list-input' ).filter( ':checked' ),
            jDropdown         = jInput.closest( '.js-e-product-favorites' );
        if ( boolHasAnyChecked.length > 0 ) {
            jDropdown.find( '.js-e-product-favorites-icon' ).addClass( 'favorite-icon-selected' );
        }
        else {
            jDropdown.find( '.js-e-product-favorites-icon' ).removeClass( 'favorite-icon-selected' );
        }
    },
    addToNewList: function ( jListItems, jsonData ) {
        var jNewListInput = jListItems.find( '.js-e-product-favorites-list-input[data-list-id="' + jsonData.lastAdded.id + '"]' );
        if ( jQuery( '.js-e-cart' ).length === 1 || jQuery( '.js-e-orders-form' ).length === 1  ) {
            jNewListInput = jListItems.find( `.js-e-product-favorites-list-cart[data-list-id="${jsonData.lastAdded.id}"]` );
            e4.favorites.addListToFavorites( jNewListInput.get(0) );
        }
        else {
            jNewListInput.prop( 'checked', true );
            e4.favorites.toggleList( jNewListInput.get( 0 ) );
            jNewListInput.closest( '.dropdown-item' ).addClass( 'bg-light' );
        }
    },
    setNewListInputFocus: function ( event ) {
        jQuery( event.target ).find( '.js-e-product-favorites-add-new-list-name-input' ).trigger( 'focus' );
    },
    createNewList: function ( domElm ) {
        var jFavoriteList          = jQuery( domElm ).closest( '.js-e-product-favorites' ),
            objProductDataSettings = jFavoriteList.data(),
            jListItems             = jFavoriteList.find( '.js-e-product-favorites-lists' ),
            jNameInput             = jFavoriteList.find( '.js-e-product-favorites-add-new-list-name-input' ),
            strUrl                 = jFavoriteList.data( 'favoritesPage' ) + '&CC' + jFavoriteList.data( 'paragraphId' ) + '=CreateList';
        if ( jNameInput.val() !== '' ) {
            console.log( 'POST', domElm, strUrl )
            e4.favorites.ajax( {
                url: '/' + strUrl,
                method: 'POST',
                dataType: 'html',
                beforeSend: function () {
                    jFavoriteList.find( '.js-e-product-favorites-loader' ).addClass( 'is-loading' );
                },
                data: {
                    FavoriteCmd: 'CreateFavoriteList',
                    Name: jNameInput.val(),
                    Redirect: false
                }
            }, function () {
                jFavoriteList.find( '.js-e-product-favorites-loader' ).removeClass( 'is-loading' );
                e4.favorites.ajax( {
                    data: objProductDataSettings
                }, function ( jsonData ) {
                    e4.favorites.buildList( jListItems, jsonData );
                    e4.favorites.addToNewList( jListItems, jsonData );
                } );
                jNameInput.val( '' );
                jFavoriteList.find( '.js-e-product-favorites-add-new-list' ).collapse( 'hide' );
            } );
        }
        else {
            jNameInput.trigger( 'focus' );
        }
    },
    getListData: function ( event ) {
        var objProductDataSettings = jQuery( event.target ).data(),
            jListItems             = jQuery( event.target ).find( '.js-e-product-favorites-lists' );
        e4.favorites.ajax( {
            data: objProductDataSettings,
            beforeSend: function () {
                jQuery( event.target ).find( '.js-e-product-favorites-loader' ).addClass( 'is-loading' );
            }
        }, function ( jsonData ) {
            e4.favorites.buildList( jListItems, jsonData );
            jQuery( event.target ).find( '.js-e-product-favorites-loader' ).removeClass( 'is-loading' );
        } );
    },
    clearLists: function ( event ) {
        jQuery( event.target ).find( '.js-e-product-favorites-lists' ).html( '' );
    },
    buildList: function ( jListItems, jsonData ) {
        if(e4.handlebars.tmpl.favoritesLists){
            jListItems.html( e4.handlebars.tmpl.favoritesLists( jsonData ) );
        }
        if(e4.handlebars.tmpl.favoritesListsCart){
            jListItems.html( e4.handlebars.tmpl.favoritesListsCart( jsonData ) );
        }
        
        
    }
};
